import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { EMPTY_ARRAY } from '../../../constants/globalConstants'
import { Circles } from 'react-loader-spinner'
import { renderNoResults } from '../../../components/global/NoDataFound'
import { getPermitRequestList } from '../../../redux/actions/PermitRequestAction'
import { phoneMasker } from '../../../utils/helper'
// import { errorMessages } from '../../../constants/errorMessages'
// import { Link } from 'react-router-dom'
import moment from 'moment'

// let moment = require('moment')

function PermitRequest(props) {
    const { dispatch, loader } = props
    const [permitRequestList, setPermitRequestList] = useState(EMPTY_ARRAY)
    // const [userData, setUserData] = useState(EMPTY_OBJECT)
    const [displayVehicle, setDisplayVehicle] = useState(false)


    useEffect(() => {
        // setTimeout(
            dispatch(getPermitRequestList()).then((res) => {
               
                if (res?.data && res?.data.length > 0) {
                    // let permitrecord=res?.data?.filter((v)=>v.approved_status != '1')//PIMS-10316 point 13
                    let permitrecord=res?.data//PIMS-10316 point 13
                   
                    setPermitRequestList(permitrecord)
                } else {
                    setPermitRequestList('')
                }
            }).catch(() => {
                setPermitRequestList('')
            })
            // , 500)

    }, [EMPTY_ARRAY])

    const handleshowVehicle = () => {
        setDisplayVehicle(!displayVehicle)
    }

    return (
        loader ? <span className='ms-2 d-flex justify-content-center'><Circles
            height="50"
            width="50"
            color="var(--bs-primary)"
            ariaLabel="circles-loading"
            visible={true}
        /></span> :
            <div>
                <div className="d-flex justify-content-between mb-4">
                    <h4 className="fw-bold">Permit Request </h4>
                </div>
                {permitRequestList?.length > 0 ? <ul className="permitList">
                    {permitRequestList?.map((item, index) => {
                        if (item == null) return null
                        return (
                            <li className={`TicketCardStyle mb-5 ${item?.approved  && item?.approved_status == '1' ? 'active border-success ' :  item?.is_rejected == '1' ? 'inactive border-danger ' : 'border-warning'}`} key={index}>
                               
                               <div className='d-flex justify-content-sm-between mb-4 gap-2 align-items-sm-end flex-column flex-sm-row'>
                                    <div id='titles' className='d-flex gap-2  '>
                                        <i className={`fa fa-parking fa-2x   ${item?.approved  && item?.approved_status == '1' ? ' text-success ' :  item?.is_rejected == '1' ? 'text-danger ' : 'text-secondary'}`}></i>
                                        <div  >
                                            <h4 style={{lineHeight:'0.7'}} className={`mb-0 fw-bold d-block  lh-0  ${item?.approved  && item?.approved_status == '1' ? ' text-success ' :  item?.is_rejected == '1' ? 'text-danger ' : 'text-secondary'} `}>  {item?.facility?.full_name ? `${item?.facility?.full_name} -` : ''} </h4>
                                            <small>{item?.permit_type_name}</small>

                                        </div>

                                       
                                        {/* <small className={item?.is_expired == 0 && item?.cancelled_at == null ? 'text-success' : 'text-white'}><i className='fa fa-circle '></i> {item?.is_expired == 0 && item?.cancelled_at == null ? 'Active' : item?.cancelled_at == null ? 'In-active' : 'Canceled'}</small> */}
                                    </div>
                                    <div className=''>
                                        <small className='fw-bold small lh-0 d-block text-muted'>Permit Status  </small> 
                                        <p className='small m-0'> {item?.approved  && item?.approved_status == '1' ? 'Approved' : item?.is_rejected == null ? 'Pending' : 'Rejected'}</p>
                                    </div>

                                    <div className=''>
                                        <small className='fw-bold small lh-0 d-block text-muted'>Request date  </small> 
                                        <p className='small m-0'> {moment(item?.created_at).format('MM/DD/YYYY')}</p>
                                    </div>


                                    <div id='actionButtons' className='text-end' >
                                    <b className='text-muted small lh-0'>Refrence ID: </b>
                                    <h5 className='text-black m-0 fw-bold lh-0 '>{item?.tracking_code}</h5>
                                    </div>
                                   
                                </div>
                                <div className='border border-dashed my-4 d-block w-100'></div>
                               
                               {/* <div className={item?.approved  && item?.approved_status == '1' ? 'card-header border-0 bg-success bg-opacity-10' : item?.is_rejected == null ?  'card-header border-0 bg-info bg-opacity-10' : 'card-header border-0 bg-danger bg-opacity-10'} >
                                    <div className='d-flex justify-content-end'>
                                        <small className={item?.approved  && item?.approved_status == '1' ? 'text-success' :  item?.is_rejected == null ? 'text-info' : 'text-white' }><i className='fa fa-circle '></i> {item?.approved  && item?.approved_status == '1' ? 'Approved' : item?.is_rejected == null ? 'Pending' : 'Rejected'}</small>
                                    </div>
                                </div> */}
                          
                                    <div className='row g-2'>
                                        
                                        <div className='col-md-4 '>
                                            <p><b className='text-muted small'>Name: </b><span className='text-black small'>{item?.name}</span></p>
                                        </div>
                                        <div className='col-sm col-smmd-4 '>
                                            <p><b className='text-muted small'>Email: </b><span className='text-black small'>{item?.email}</span></p>
                                        </div>
                                        <div className='col-md-4 '>
                                            <p><b className='text-muted small'>Phone: </b><span className='text-black small'>{phoneMasker(item?.phone)}</span></p>
                                        </div>
                                        {item?.license_number && <div className='col-md-4  d-none'>
                                            <span><h5 className='mb-0 fw-bold text-muted small'>Driver License No.:</h5>
                                                <p><b className='text-black small'>{item?.license_number}</b></p></span>

                                            {/* <p className='text-muted mb-0  '>{item?.user?.license_number}<br/>  <b>Driving License No.</b></p> */}
                                        </div>}

                                    </div>

                                    <div className='bg-light horizontal-gradient my-3 p-3 rounded-4'>
                                    <div className='d-flex align-items-sm-center gap-sm-5 gap-2 flex-column  flex-sm-row'>
                                        <h5 className='fw-bold m-0 ' > <i className='fa fa-file me-2'></i>  Uploaded Document - </h5>

                                        {item?.permit_doc?.length > 0 ?
                                            item?.permit_doc?.map((item, index) => {
                                                return (

                                                    <a key={index} href={`${item[item?.document_key]}`} target='_blank' rel="noreferrer" className='text-primary text-start btn p-0 '> <span className="text-dark">{item?.doc_name}</span> <i className='fa fa-eye'></i></a>

                                                )
                                            })
                                            : <div className='col'>
                                                <span className='fontsize85'>
                                                    N/A
                                                </span>
                                            </div>}
                                    </div>
                                </div>
                           

                                    {item?.permit_vehicle && <div className='my-3'>
                                    <div className="d-flex align-items-center mb-2 w-full justify-content-between">
                                        <b>Vehicles</b>                                             {item?.permit_vehicle?.length > 1 ? <button className='btn btn-light btn-sm' onClick={() => handleshowVehicle()}>{displayVehicle ? 'Hide All' : 'View All'}</button> : null}
                                    </div>
                                    <div className='table-responsive'>
                                    <table style={{minWidth:'400px'}} className='table table-sm table-borderless' >
                                        <thead scope="row" >
                                            {item?.permit_vehicle[0]?.vehicle?.license_plate_number && <th scope='col' className='small text-muted fw-normal '>License Plate</th>
                                            }
                                            {item?.permit_vehicle[0]?.vehicle?.color && <th scope='col' className='small text-muted fw-normal ' >Color</th>
                                            }
                                            {item?.permit_vehicle[0]?.vehicle?.make && <th scope='col' className='small text-muted fw-normal '>Make</th>
                                            }
                                            {item?.permit_vehicle[0]?.vehicle?.model && <th scope='col' className='small text-muted fw-normal ' >Model</th>
                                            }
                                        </thead>
                                        <tbody>
                                           {!displayVehicle &&  <tr>
                                                {item?.permit_vehicle[0]?.vehicle?.license_plate_number && <td className='p-0 lh-4'  ><img height="18px" className='opacity-25' src="https://cdn-icons-png.flaticon.com/512/2260/2260153.png"/>  {item?.permit_vehicle[0]?.vehicle?.license_plate_number}</td>
                                                }
                                                {item?.permit_vehicle[0]?.vehicle?.color && <td className='p-0 lh-4'  > <i className='fa small opacity-25 fa-palette'></i> {item?.permit_vehicle[0]?.vehicle?.color}</td>
                                                }
                                                {item?.permit_vehicle[0]?.vehicle?.make && <td className='p-0 lh-4'   > <i className='fa small opacity-25 fa-car'></i> {item?.permit_vehicle[0]?.vehicle?.make}</td>
                                                }
                                                {item?.permit_vehicle[0]?.vehicle?.model && <td className='p-0 lh-4'  > <i className='fa small opacity-25 fa-car-side'></i>  {item?.permit_vehicle[0]?.vehicle?.model}</td>
                                                }
                                            </tr>}


                                            {displayVehicle && item?.permit_vehicle && <>
                                                    {item?.permit_vehicle?.length > 0 && item?.permit_vehicle?.map((item, index) => {
                                                        return <tr key={index}>
                                                            <td className='p-0 lh-4' ><img height="18px" className='opacity-25' src="https://cdn-icons-png.flaticon.com/512/2260/2260153.png"/> {item?.vehicle?.license_plate_number ? item?.vehicle?.license_plate_number : '-'}</td>
                                                            <td className='p-0 lh-4' ><i className='fa small fa-palette opacity-25'></i> {item?.vehicle?.color ? item?.vehicle?.color : '-'}</td>
                                                            <td className='p-0 lh-4' ><i className='fa small fa-car opacity-25'></i> {item?.vehicle?.make ? item?.vehicle?.make : '-'}</td>
                                                            <td className='p-0 lh-4' ><i className='fa small fa-car-side opacity-25'></i> {item?.vehicle?.model ? item?.vehicle?.model : '-'}</td>
                                                        </tr>
                                                    })}
                                             
                                            

                                            </>}

                                        </tbody>
                                    </table></div>

                                </div>
                                }
                                    {/*  transtion card detils */}
                                    <div className='border border-dashed my-4 d-block w-100'></div>
                                <div className='row g-2' >
                            
                                    <div className='col-md-4'>
                                        <small className='fw-bold text-muted d-block'> Permit Rate  </small> 
                                        <p className='m-0'>{item?.permit_rate?.rate}</p>
                                    </div>
                                    <div className='col-md-4'>
                                        <small className='fw-bold text-muted d-block'> Amount  </small> 
                                        <p className='m-0'>{item?.permit_final_amount}</p>
                                    </div>
                                   {item?.paymentDetails?.card_last_four ? <div className='col-md-4'>
                                        <small className='fw-bold text-muted d-block'>Card details </small> 
                                        <p className='m-0'>Ending With - 
                                            {/* <i className="fa-brands fa-cc-visa"></i> */}
                                             {item?.paymentDetails?.card_last_four} | Exp - {item?.paymentDetails?.expiry ? item?.paymentDetails?.expiry?.slice(0,2) +'/'+ item?.paymentDetails?.expiry?.slice(2,4) :'-'}</p>
                                    </div> :''}
                                    {/* <div className='col-md-4'>
                                        <small className='fw-bold text-muted d-block'> Payment Date  </small> 
                                        <p className='m-0'><i className='fa fa-clock'></i>  12th Aug, 2024 12:20 PM </p>
                                    </div> */}
                                    </div>





                                

                         


                                      {/* uploaded documents */}
                           

                                    {/* <div className='row align-items-center justify-content-between  '>
                                        <div className='col-sm-4 text-end order-sm-1 order-4 '>
                                            {item?.transaction?.total && <p className='mb-0'><b className='text-muted fw-bold'>Paid: </b> ${item?.transaction?.total}</p>}
                                        </div>
                                        <div className='col-sm-4 '>
                                            <small><b className='text-muted fw-bold'>Valid Till:</b>  <br className='d-block d-sm-none' />{item?.formatted_desired_end_date}</small>
                                        </div>
                                        <div className='col-sm-4 '>
                                            <small><b className='text-muted fw-bold'>Autopay Enabled</b> - <br className='d-block d-sm-none' />{item?.user_consent ? item?.user_consent == 1 ? 'Yes' : 'No' : 'Yes'}</small>
                                        </div>
                                    </div> */}
                                    {/* <div>
                                        <small className='text-danger'>{userData?.user?.license_number != item?.license_number ? errorMessages?.licenseAlertMessage : ''}</small>
                                    </div> */}
                             
                            </li>
                        )
                    })}
                </ul> : renderNoResults()}
            </div>
    )
}

PermitRequest.propTypes = {
    dispatch: PropTypes.func,
    loader: PropTypes.bool,
}

PermitRequest.defaulProps = {
    dispatch: noop,
    loader: PropTypes.bool,
}

function mapStateToProps({ permitRequestReducer }) {
    return {
        loader: permitRequestReducer?.loader,
    }
}
export default connect(mapStateToProps)(PermitRequest)